import React from 'react';
import styled from '@emotion/styled';
import Number from '../../../../../../utils/number';

export const PlanoCard = ({
  titulo,
  quantidadeAdicional,
  valorMensal,
  valorAnual,
}) => {
  const valorMensalWithCurrencyFormat = valorMensal
    ? Number.currencyFormat(valorMensal)
    : null;
  const valorAnualWithCurrencyFormat = valorAnual
    ? Number.currencyFormat(valorAnual)
    : null;
  return (
    <Card>
      <Row>
        <Title>{titulo}</Title>
      </Row>
      {quantidadeAdicional && (
        <ContainerValor>
          <ValorTextStyle>Qtd de dependentes:</ValorTextStyle>
          <ValorValueStyle>{quantidadeAdicional}</ValorValueStyle>
        </ContainerValor>
      )}
      {valorMensalWithCurrencyFormat && (
        <ContainerValor>
          <ValorTextStyle>Valor mensal:</ValorTextStyle>
          <ValorValueStyle>{valorMensalWithCurrencyFormat}</ValorValueStyle>
        </ContainerValor>
      )}
      {valorAnualWithCurrencyFormat && (
        <ContainerValor>
          <ValorTextStyle>Valor Anual:</ValorTextStyle>
          <ValorValueStyle>{valorAnualWithCurrencyFormat}</ValorValueStyle>
        </ContainerValor>
      )}
    </Card>
  );
};

const Card = styled.div`
  width: 300px;
  height: fit-content;
  border-radius: 16px;
  padding: 16px;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`;
const ContainerValor = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  height: 25px;
`;

const Title = styled.h1`
  font-family: 'Poppins';
  font-weight: 700;
  font-size: 14px;
`;

const ValorTextStyle = styled.p`
  color: #09101d;
  font-size: 12px;
  font-weight: 500;
`;
const ValorValueStyle = styled.p`
  color: #09101d;
  font-size: 12px;
  font-weight: 700;
`;
